<div class="container-fluid m-0 p-0" *ngIf="!showLoader">
    <form [formGroup]="updateYear" (change)="updateYearChange()" (submit)="updateYearSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"UPDATE_YEAR" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/academics/years"
                    *ngIf="!updating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!updating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="updating"></app-loader>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ID" | translate | titlecase }}</label>
                                <input type="number" class="form-control" [value]="yearId" readonly>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ARABIC_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameAr">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateYear.controls.nameAr.touched && updateYear.controls.nameAr.invalid && updateYear.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ENGLISH_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEn">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateYear.controls.nameEn.touched && updateYear.controls.nameEn.invalid && updateYear.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ABBRIVIATION" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="abbriviation">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateYear.controls.abbriviation.touched && updateYear.controls.abbriviation.invalid && updateYear.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "START_DATE" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="startDate">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateYear.controls.startDate.touched && updateYear.controls.startDate.invalid && updateYear.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "END_DATE" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="endDate"/>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateYear.controls.endDate.touched && updateYear.controls.endDate.invalid && updateYear.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"DAYS" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="days">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateYear.controls.days.touched && updateYear.controls.days.invalid && updateYear.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>
